import { gql } from '@apollo/client';

export const BID_FIELDS = gql`
  fragment BidFields on Bid {
    id
    price
    note
    paddleNumber
    paddleService { id, name, code }
    buyer { name, companyName }
    buyerUser { fullName }
    createdAt
    removedAt
  }
`;

export const AWARD_BID = gql`
  mutation AwardBid(
    $id: ID!
    $paddleServiceId: ID
  ) {
    awardBid(
      id: $id
      paddleServiceId: $paddleServiceId
    ) {
      errors { path, message }
    }
  }
`;

export const UPDATE_BID = gql`
  mutation UpdateBid(
    $id: ID!
    $paddleServiceId: ID
    $paddleNumber: String
  ) {
    updateBid(
      id: $id
      paddleServiceId: $paddleServiceId
      paddleNumber: $paddleNumber
    ) {
      errors { path, message }
    }
  }
`;